export default "__VITE_ASSET__Ihp2fHcZ__"